/**
 * Quode brand marks, transcribed from branding/assets/*.svg.
 *
 * The glyph is a search/cursor lens: emerald tile, forest ring with a diagonal
 * handle, amber lens dot. Amber appears here and nowhere else in the product.
 */

type MarkProps = {
  size?: number;
  /** Adds a slow breathing pulse to the lens dot. */
  alive?: boolean;
};

export const QuodeMark = ({ size = 32, alive = false }: MarkProps) => {
  const id = alive ? 'live' : 'still';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 144 144"
      role="img"
      aria-label="Quode"
    >
      <defs>
        <linearGradient id={`q_t_${id}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#16C78E" />
          <stop offset="1" stopColor="#0C9E6A" />
        </linearGradient>
        <radialGradient id={`q_a_${id}`} cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#FCD34D" />
          <stop offset="0.4" stopColor="#F59E0B" />
          <stop offset="0.72" stopColor="#F59E0B" stopOpacity="0.28" />
          <stop offset="1" stopColor="#F59E0B" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="144" height="144" rx="32" fill={`url(#q_t_${id})`} />
      <circle
        cx="70"
        cy="66"
        r="34"
        fill="none"
        stroke="#022C22"
        strokeWidth="13"
      />
      <line
        x1="88"
        y1="84"
        x2="113"
        y2="109"
        stroke="#022C22"
        strokeWidth="13"
        strokeLinecap="round"
      />
      <circle
        cx="70"
        cy="66"
        r="20"
        fill={`url(#q_a_${id})`}
        style={
          alive
            ? {
                animation: 'q-breathe 3.2s ease-in-out infinite',
                transformOrigin: '70px 66px',
              }
            : undefined
        }
      />
      <circle cx="70" cy="66" r="10" fill="#F59E0B" />
      <circle cx="66.5" cy="62.5" r="3.2" fill="#fff" opacity="0.6" />
    </svg>
  );
};

/** Mark plus wordmark, for the expanded sidebar and page headers. */
export const QuodeLockup = ({ size = 30 }: { size?: number }) => (
  <span
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      minWidth: 0,
    }}
  >
    <QuodeMark size={size} alive />
    <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <span
        className="q-display"
        style={{
          fontSize: 21,
          color: 'var(--q-text)',
          lineHeight: 1,
        }}
      >
        Quodin
      </span>
      <span
        className="q-eyebrow"
        style={{ fontSize: 8.5, letterSpacing: '0.2em', marginTop: 3 }}
      >
        AI Workforce
      </span>
    </span>
  </span>
);
